import React from 'react';
// import { useStyle } from '@magento/venia-ui/lib/classify';
import { useStyle } from '../../lib/util/classify';
import defaultClasses from './richContent.module.css';
import { shape, string } from 'prop-types';
// import richContentRenderers from '@magento/venia-ui/lib/components/RichContent/richContentRenderers';
import RichText from '../RichText';

/**
 * RichContent component.
 *
 * This component serves as the pool to determine which type of content is being rendered
 * and pass the data off to the correct system.
 *
 * @typedef RichContent
 * @kind functional component
 *
 * @param {Object} props React component props
 *
 * @returns {React.Element} A React component that renders Heading with optional styling properties.
 */
const RichContent = props => {
    const classes = useStyle(defaultClasses, props.classes);
    const rendererProps = {
        ...props,
        classes
    };

    if (!rendererProps.html) {
        return null;
    }

    let content = rendererProps.html;
    //check if html is build by page builder
    if (content.indexOf('data-content-type="html"') > -1) {
        const text_area = document.createElement('textarea');
        text_area.innerHTML = content;
        content = text_area.value;
    }

    return <RichText content={content} />;
    /*
    for (const Renderer of richContentRenderers) {
        const { Component, canRender } = Renderer;
        const htmlText = rendererProps.html
            ? rendererProps.html.replace(/(<([^>]+)>)/gi, '')
            : '';
        if (canRender(rendererProps.html) && htmlText.length) {
            return <Component {...rendererProps} />;
        }
    }
    // If no renderer returned a value
    if (process.env.NODE_ENV === 'development') {
        console.warn(
            `None of the following rich content renderers returned anything for the provided HTML.`,
            richContentRenderers.map(r => `<${r.name}>`),
            props.html
        );
    }
    return null;
    */
};

/**
 * Props for {@link RichContent}
 *
 * @typedef props
 *
 * @property {Object} classes An object containing the class names for the RichContent
 * @property {String} classes.root CSS class for the root container element
 * @property {String} html Content
 */
RichContent.propTypes = {
    classes: shape({
        root: string
    }),
    html: string
};

export default RichContent;
